(function () {
  // Detect Facebook/Instagram in-app browser and bail out entirely
     var ua = navigator.userAgent || '';
  var ref = document.referrer || '';
  var isIAB = ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1 ||
              ua.indexOf('Instagram') > -1 || ua.indexOf('FB_IAB') > -1 ||
              ua.indexOf('FBIOS') > -1 || ua.indexOf('FBSV') > -1 ||
              ua.indexOf('IABMV') > -1 ||
              (ua.indexOf('wv') > -1 && ref.indexOf('instagram.com') > -1) ||
              (ua.indexOf('wv') > -1 && ref.indexOf('facebook.com') > -1);


  // Also remove the render blocker immediately if present
  var renderBlocker = document.getElementById('view-transition-render-blocker');
  if (renderBlocker) renderBlocker.remove();

  if (isIAB) return; // Exit — no view transitions in IABs

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || isLowPowerDevice()) {
    return;
  }

  const idleCallback = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;

  window.addEventListener('pageswap', async (event) => {
    const { viewTransition } = /** @type {PageSwapEvent} */ (event);

    if (shouldSkipViewTransition(viewTransition)) {
      /** @type {ViewTransition | null} */ (viewTransition)?.skipTransition();
      return;
    }

    ['pointerdown', 'keydown'].forEach((eventName) => {
      document.addEventListener(
        eventName,
        () => { viewTransition.skipTransition(); },
        { once: true }
      );
    });

    document
      .querySelectorAll('[data-view-transition-type]:not([data-view-transition-triggered])')
      .forEach((element) => { element.removeAttribute('data-view-transition-type'); });

    const transitionTriggered = document.querySelector('[data-view-transition-triggered]');
    const transitionType = transitionTriggered?.getAttribute('data-view-transition-type');

    if (transitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(transitionType);
      try { sessionStorage.setItem('custom-transition-type', transitionType); } catch(e) {}
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
      try { sessionStorage.removeItem('custom-transition-type'); } catch(e) {}
    }
  });

  window.addEventListener('pagereveal', async (event) => {
    const { viewTransition } = /** @type {PageRevealEvent} */ (event);

    if (shouldSkipViewTransition(viewTransition)) {
      /** @type {ViewTransition | null} */ (viewTransition)?.skipTransition();
      return;
    }

    let customTransitionType = null;
    try { customTransitionType = sessionStorage.getItem('custom-transition-type'); } catch(e) {}

    if (customTransitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(customTransitionType);

      await viewTransition.finished;

      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');

      idleCallback(() => {
        try { sessionStorage.removeItem('custom-transition-type'); } catch(e) {}
        document.querySelectorAll('[data-view-transition-type]').forEach((element) => {
          element.removeAttribute('data-view-transition-type');
        });
      });
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
    }
  });

  function shouldSkipViewTransition(viewTransition) {
    return !(viewTransition instanceof ViewTransition) || isLowPowerDevice();
  }

  function isLowPowerDevice() {
    /* eslint-disable-next-line compat/compat */
    return Number(navigator.hardwareConcurrency) <= 2 || Number(navigator.deviceMemory) <= 2;
  }
})();
